import { ExternalLink } from 'lucide-react'

import { adminTasksTasks } from 'rails_routes'
import { Badge } from 'slab'
import { type BrokersTask } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import { assertUnreachable, snakeToSentenceCase } from '../../utils'

export default function TaskPill ({
  task,
}: {
  task: BrokersTask
}) {
  const { assign } = useWindowLocation()

  let jobType : string
  switch (task?.job?.type) {
    case 'Tasks::EnrollmentJob':
      jobType = 'Enrollment'
      break
    case 'Tasks::BinderJob':
      jobType = 'Binder'
      break
    default:
      // filter out non-enrollment tasks
      return null
  }

  return (
    <Badge
      actionIcon={ExternalLink}
      actionLabel={`View ${jobType} Task`}
      onActionClick={() => {
        assign(adminTasksTasks.show({ id: task.id }))
      }}
      type={getBadgeType(task)}
    >
      {jobType} Task {snakeToSentenceCase(task.status)}
    </Badge>
  )
}

function getBadgeType (task: BrokersTask) {
  switch (task.status) {
    case 'pending':
      return 'info'
    case 'canceled':
    case 'excluded':
      return 'neutral'
    case 'failed':
      return 'critical'
    case 'completed':
      return 'success'
    default:
      assertUnreachable(task.status as never)
  }
}
